import { render, staticRenderFns } from "./imgCom.vue?vue&type=template&id=1b7d054a&scoped=true&"
import script from "./imgCom.vue?vue&type=script&lang=js&"
export * from "./imgCom.vue?vue&type=script&lang=js&"
import style0 from "./imgCom.vue?vue&type=style&index=0&id=1b7d054a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b7d054a",
  null
  
)

export default component.exports